<template>
	<div :style="{ top: `${wizardPositionY}px`, left: `${wizardPositionX}px` }" class="floating-wizard-content bg-white shadow-lg rounded-lg px-4 pb-3 pt-0">
		<div class="mb-3 d-flex justify-content-center">
			<div class="w-50 bg-light shadow rounded-bottom">
				<component :is="getLucideIcon('Settings')" :size="14" :stroke-width="2" class="mr-2" />
				{{ FormMSG(1, 'Column settings wizard') }}
			</div>
		</div>
		<div class="d-flex flex-wrap">
			<div class="w-100 d-flex flex-wrap">
				<div class="w-100 px-2">
					<b-form-group :label="FormMSG(2, 'Category')">
						<cost-center-select
							:all-categories="allCategories"
							:edit-data="selectionData.costCode"
							@change="(e) => $emit('wizard:setSelectionDataCostCode', e)"
							@click.stop
						/>
					</b-form-group>
				</div>
				<div class="w-100 px-2" v-if="customFlags.length > 0">
					<b-form-group :label="`${FormMSG(3, 'Tax code')}`">
						<v-select
							ref="flag-item"
							label="text"
							:value="selectionData.taxeFlags[0] ? selectionData.taxeFlags[0].id : null"
							:options="taxOptions"
							:reduce="(option) => option.value"
							:get-option-label="(option) => (option.item ? option.item.factor : '')"
							placeholder="..."
							@input="(e) => $emit('wizard:setSelectionDataTaxCode', e)"
						>
							<template #option="option">
								<div class="text-bold" v-if="option.disabled">{{ option.text }}</div>
								<div class="text-color ml-3" v-else>{{ option.text }} - {{ option.item.name }} ({{ option.item.factor }}%)</div>
							</template>
						</v-select>
					</b-form-group>
				</div>
			</div>
			<div class="w-100 d-flex flex-wrap" v-if="customFlags.length > 0">
				<div v-for="(flag, index) in customFlags" :key="index" class="w-50 px-2">
					<b-form-group :label="`${flag.name.toUpperCase()}`">
						<v-select
							label="name"
							placeholder="..."
							:value="selectionData.customFlags.find((flag) => customFlags[index].projectFlagItem.some((item) => +item.id === +flag.id))"
							:options="flag.projectFlagItem"
							:reduce="(option) => option.id"
							@input="(e) => $emit('wizard:setSelectionDataCustomFlags', e, flag)"
						/>
					</b-form-group>
				</div>
			</div>
		</div>
		<div class="d-flex justify-content-between my-3" style="gap: 7px">
			<b-button size="sm" variant="link" class="text-danger" @click="$emit('wizard:clearSelection')">
				<component :is="getLucideIcon('X')" :size="16" :stroke-width="2.5" class="mr-2" />
				<span>{{ FormMSG(4, 'Close wizard') }}</span>
			</b-button>
			<div class="d-inline-flex align-items-center" style="gap: 20px">
				<span>{{ `(${selectedItemsCount})` + ' ' + FormMSG(55, 'selected') }}</span>
				<b-button size="sm" variant="success" class="rounded" @click.stop="$emit('wizard:computeSelection')">
					<component :is="getLucideIcon('Check')" :size="16" color="#fff" :stroke-width="2.5" class="mr-2" />
					{{ FormMSG(5, 'Compute') }}
				</b-button>
			</div>
		</div>
	</div>
</template>

<script>
// mixin
import globalMixin from '@/mixins/global.mixin';
import languageMessages from '@/mixins/languageMessages';

// component
import CostCenterSelect from './CostCodeSelect';

export default {
	name: 'ExpenseItemColumnWizard',
	mixins: [globalMixin, languageMessages],
	components: {
		CostCenterSelect
	},
	props: {
		wizardPositionX: {
			type: Number,
			required: true
		},
		wizardPositionY: {
			type: Number,
			required: true
		},
		taxOptions: {
			type: Array,
			required: false,
			default: () => []
		},
		customFlags: {
			type: Array,
			required: false,
			default: () => []
		},
		allCategories: {
			type: Array,
			required: false,
			default: () => []
		},
		selectionData: {
			type: Object,
			required: false,
			default: () => {}
		},
		selectedItemsCount: {
			type: Number,
			required: false,
			default: 0
		}
	}
};
</script>

<style>
.floating-wizard-content {
	position: fixed;
	width: 25%;
	text-align: center;
	z-index: 6000;
}
</style>
